import { render, staticRenderFns } from "./MenuType.vue?vue&type=template&id=721ab83e&scoped=true"
import script from "./MenuType.vue?vue&type=script&lang=js"
export * from "./MenuType.vue?vue&type=script&lang=js"
import style0 from "./MenuType.vue?vue&type=style&index=0&id=721ab83e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721ab83e",
  null
  
)

export default component.exports